import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://llohruvkcdcyolmwlivx.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxsb2hydXZrY2RjeW9sbXdsaXZ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk5NDgxNzEsImV4cCI6MjA2NTUyNDE3MX0.zpLmSQJNGUfOjsoo_Xe_r852Z78sU2u3k0kezTEf4io'

// ✅ Configuración más robusta para persistencia
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    // ✅ Habilitar persistencia de sesión
    persistSession: true,
    // ✅ Usar localStorage para persistir la sesión
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    // ✅ Configurar tiempo de expiración del token (opcional)
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // ✅ Configuración adicional para mejor persistencia
    flowType: 'pkce',
    debug: true // Temporal para debug
  },
  // ✅ Configuración global
  global: {
    headers: {
      'X-Client-Info': 'app-constructoras'
    }
  }
})

// ✅ Función helper para verificar estado de sesión
export const checkSessionStatus = async () => {
  try {
    const { data: { session }, error } = await supabase.auth.getSession()
    
    console.log('🔍 Estado de sesión actual:', {
      hasSession: !!session,
      userEmail: session?.user?.email,
      expiresAt: session?.expires_at,
      currentTime: Math.floor(Date.now() / 1000),
      isExpired: session?.expires_at ? session.expires_at < Math.floor(Date.now() / 1000) : true
    })
    
    return { session, error }
  } catch (err) {
    console.error('❌ Error verificando sesión:', err)
    return { session: null, error: err }
  }
}

// ✅ Función para verificar y crear bucket de logos
export const ensureLogosBucket = async () => {
  try {
    console.log('🔍 Verificando bucket de logos...')
    
    // Intentar listar archivos del bucket para verificar si existe
    const { data, error } = await supabase.storage
      .from('logos')
      .list('', { limit: 1 })
    
    if (error && error.message.includes('not found')) {
      console.log('📦 Bucket de logos no existe, creando...')
      // En producción, esto debería hacerse desde el dashboard de Supabase
      // Por ahora, solo logueamos el error
      console.warn('⚠️ Bucket de logos no existe. Por favor, créalo manualmente en Supabase Dashboard.')
      return false
    }
    
    console.log('✅ Bucket de logos existe')
    return true
  } catch (err) {
    console.error('❌ Error verificando bucket de logos:', err)
    return false
  }
}